import {
  initApp3Success,
  initApp3Connection,
  initApp3ReadyServer,
  reconnect3Success,
  runEffect3Success,
  dispatchEvent3Success,
  loadLocale3Success,
  loadConfiguration3Success,
  loadView3Success,
  loadForm3Success,
  loadForm3Fail,
  changeStatus3Success,
  login3Success,
  login3Failed,
  pub3,
  closeForm3,
  reconnect3,
  streamUpload3Success,
  removeUpload3Success,
  initUpload3Success,
  setUserPersistentProfile,
  setValidationError,
  setForm3Section,
  setValidationMessage,
  incForm3Section,
  updateUserAttributes,
  error,
  warning,
  addNote3,
  loadHTMLTemplate3Success,
  pubsub3FormDataUpdate,
  loginSession


} from "../actions";

import { push,replace } from "connected-react-router";
import get from 'lodash/get'

import { addSocketHandler } from "../socket";

const eventHandlers =  () => {
  addSocketHandler(null, "error", res => {
    return error(res)
    // alert(res)
  });

  addSocketHandler(null, "warning", res => {
    return warning(res)
    // alert(res)
  });

  // handle sessionId for login/collect methods
  addSocketHandler(null, "login3/collect", session => {
    return loginSession(session)
  });

  addSocketHandler(null, "login3/metadata", props => {
    return loginMetadata(props)
  });

  // 20220301 - This might be old. TBR???
  // addSocketHandler(null, "connect", res => {
  //   const jwt = localStorage.getItem("_jwt");
  //   if( jwt ) {
  //     return reconnect3({token:jwt})
  //   }
  // });

  addSocketHandler(null, "connected", res => {
    const jwt = localStorage.getItem("_jwt");

    // if( jwt ) {
    //   return reconnect3({token:jwt})
    // }
    return initApp3ReadyServer({})
  });

  // connect2 is an experimental function to see if it helps 
  // unwanted logouts on portal
  addSocketHandler(null, "connect2", res => {
    const jwt = localStorage.getItem("_jwt");
    if( jwt ) {
      return reconnect3({token:jwt})
    }

    
  });

  addSocketHandler(null, "reconnect3", res => {

    if( ! res ) {
      
      //return [push("/login")];
    }
    return(reconnect3Success(
      {
        userName: res.username,
        userID: res.userid,
        roles: res.roles,
        url: res.url,
        orgId: res.orgId,
        orgName: res.orgName,
        orgColor: res.orgColor,
        configuration: res.configuration,
        permissions: res.permissions,
        user: {},
        theme: res.theme,
        themes: res.themes,
        defaultBuilderRoles: res.defaultBuilderRoles,
        userPersistentProfile: res.userPersistentProfile
      }
    ));
  });

  

  addSocketHandler(null, "login/failed", res => {
    return login3Failed({errorMsg: res.message ? res.message: 'Login failed'})
  })

  /**
   * This is issued when we have an illegal/non-valid token. Then we drop the token from localStorage and proceed as anonymous
   */
  addSocketHandler(null, "dropToken", res => {
    localStorage.removeItem('_jwt');
    return(initApp3Success({}));
  });


  addSocketHandler(null, "initApp3Success", res => {
    return(initApp3Success({}));
  });

  addSocketHandler(null, "htmlTemplates", templates => {
    return loadHTMLTemplate3Success(templates)
  });

  // open up a new tab
  addSocketHandler(null, "_blank", res => {
    window.open(res, '_blank').focus();
  })

  // open up a link only if we are in mobile (this is a special case to open BankID app)
  // ref: https://stackoverflow.com/a/11381730/13569756
  // addSocketHandler(null, "_mobile", res => {
  //   let check = false;
  //   (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
 
  //   if( check ) {
  //     window.location = res
  //   }

  // })

  addSocketHandler(null, "redirect", res => {
    if( ! res ) {
      // no url was supplied, ignore this request
      return
    }

    if( res.startsWith('http') || res.startsWith('bankid') ) {
      window.location = res
    } else {

      // check for query params
      const splitURL = res.split('?')
      
      return(push({
        pathname:splitURL[0],
        search: splitURL[1] ? '?' + splitURL[1] : null
      }))

      //return(push(res));
    }
  });

  addSocketHandler(null, "hardRedirect", res => {
    if( ! res ) {
      // no url was supplied, ignore this request
      return
    }

    window.location.assign(`${window.location.origin + res}`)
    // window.location = res
  });

  addSocketHandler(null, "reconnect3Success", res => {
    return(reconnect3Success({}));
  });

  

  addSocketHandler(null, "user", res => {


    return login3Success({
      userName: res.username,
      user:res,
      userPersistentProfile: res.userPersistentProfile
    })
    // return(push(res));
  });

  /** update user attribues. emitted when attributes are changed from server, such as QID */
  addSocketHandler(null, "user_update", res => {
    return updateUserAttributes(res)
    // return(push(res));
  });

  addSocketHandler(null, "userPersistentProfile", res => {
    return setUserPersistentProfile(
      res,
      true
    )
  });

  



  addSocketHandler(null, "lang/get", res => {
    return(loadLocale3Success(res.data));
  });

  addSocketHandler(null, "portal/loadConfiguration3", res => {
    return(loadConfiguration3Success(res.data));
  });

  addSocketHandler(null, "portal/loadView3", res => {
    return(loadView3Success(res.data));
  });

  addSocketHandler(null, "portal/changeStatus3", res => {
    return [changeStatus3Success(res.data),setForm3Section({index:0})];
  });

  addSocketHandler(null, "portal/loadForm3", res => {
    const formDataId = get(res,'data.formData._id')
    if( res.data ) {
      return( loadForm3Success(res.data));
    } else {
      return( loadForm3Fail({err: res.err}));
    }

  });

  addSocketHandler(null, "router/replace", res => {
    return(replace(res.url));
  });

  addSocketHandler(null, "router/push", res => {
    return(push(res.url));
  });

  addSocketHandler(null, "form3/close", res => {
    return closeForm3({})
  });

  addSocketHandler(null, "form3/validationError", res => {
    const { key, results } = res
    return setValidationError({key, results})
  });

  addSocketHandler(null, "form3/changeActiveSection", res => {
    const { key, results } = res
    return setValidationError({key, results})
  });

  addSocketHandler(null, "form3/setActiveSection", res => {
    const { index, direction } = res
    return setForm3Section({index, direction})
  });

  // used for login components to increase one section
  addSocketHandler(null, "form3/nextSection", res => {
    return incForm3Section({})
  });

  

  addSocketHandler(null, "form3/validationMessage", res => {
    const { type, message, heading } = res
    return setValidationMessage({type, message, heading})
  });

  addSocketHandler(null, "portal/initUpload3", res => {
    return initUpload3Success({...res})
  });

  addSocketHandler(null, "portal/streamUpload3", res => {
    return streamUpload3Success({chunkId: res.chunkId, assetId:res.assetId})
  });

  addSocketHandler(null, "portal/removeUpload3", res => {
    return removeUpload3Success({assetId: res.assetId})
  });

  /**
   * Replace activeFormId in localStorage to reflect the current form
   */
  addSocketHandler(null, "form/replaceId", res => {
    // if( res.reset ) {
    //   localStorage.removeItem('activeSectionIndex');
    // }

    // localStorage.setItem('activeFormDataId', res.id);

    //return replace('http://localhost:3000/s?formId=xx&formDataId=',res.id)
    
  });

  addSocketHandler(null, "refresh-jwt", token => {
    if( token ) {
      localStorage.setItem('_jwt', token);
    }
    return
  });


  addSocketHandler(null, "jwt", token => {
    if( token ) {
      localStorage.setItem('_jwt', token);
    }
    // 20220301
    return reconnect3({token})
  });

  addSocketHandler(null, "runEffect3", res => {
    const { data , err } = res;


    if( ! data ) {
      return
    }

    

    const [ _data, _errors,_warnings ] = data

    let _actions = []

    if( _warnings ) {
      const __warnings = ! Array.isArray(_warnings) ? [ _warnings ] : _warnings
      _actions = __warnings.map( w => {
        return warning(w)
      })
    }

    if( _errors ) {
      const __errors = ! Array.isArray(_errors) ? [ _errors ] : _errors
      _actions = __errors.map( w => {
        return error(w)
      })
    }

    _actions.push(runEffect3Success({data:_data, effectId: res._id}))

    return(_actions);
    // return(loadView3Success(res.data));
  });

  

  addSocketHandler(null, "portal/dispatchEvent3", res => {
    const { data , err } = res;
    // const [ success, errors ] = data;


    const [ _data, _errors,_warnings ] = data

    let _actions = []

    if( _warnings ) {
      const __warnings = ! Array.isArray(_warnings) ? [ _warnings ] : _warnings
      _actions = __warnings.map( w => {
        return warning(w)
      })
    }

    if( _errors ) {
      const __errors = ! Array.isArray(_errors) ? [ _errors ] : _errors
      _actions = __errors.map( w => {
        return error(w)
      })
    }

    _actions.push(dispatchEvent3Success({data : _data}))

    return(_actions);
  });

  /**
   * PUBSUB: start
   */
  addSocketHandler(null, "pub", res => {

    switch( res.channel ) {
      case "notification" : {
        const { channel = 'default', msg = 'No message', id} = res;
        return (pub3({ channel, msg, id }));
      }
    }

    switch (res.type) {
      case "chat" : {
        break;
      }
      case "dirty":
        //return (_dirty({ _id: res.payload._id, spId: res.payload.spId }));
        break;
      // case "pub" : {
      //   const { channel = 'default', msg = 'No message'} = res;
      //   return (pub3({ channel, message }));
      // }
      case "pub": {
        const { channel = "default", message = {} } = res;

        switch ( message.type ) {
          case "save": {
            const { key, value,data } = message
            return pubsub3FormDataUpdate({formDataId: channel, key, value,data})

          }
          case "chat": {
            const { payload = {} } = message
            const { noteId, note, assetId } = payload
            return addNote3({noSaga:true, formDataId: res.channel, noteType: 'external', noteId, note, origin: 'admin'  })
          }

        }

        return pub3({ channel, message });

        //return pub3({ channel, message });
      }
      default:
        break;
    }
  });





}

export default eventHandlers
